export default __webpack_public_path__ + "static/media/arrow_left.eb78babf.svg";